export const sortByPriority = (list) => {
  return [...list].sort((a, b) => a.priority - b.priority)
}